export const ICandidateKycAccount = Object.freeze({
  code: "code",
  type: "type",
  data: "data",
});

export class CandidateKycAccountModel {
  constructor(data = {}) {
    this[ICandidateKycAccount.code] = data[ICandidateKycAccount.code];
    this[ICandidateKycAccount.type] = data[ICandidateKycAccount.type];
    this[ICandidateKycAccount.data] = data[ICandidateKycAccount.data];
  }

  getType() {
    return this[ICandidateKycAccount.type];
  }

  getCode() {
    return this[ICandidateKycAccount.code];
  }

  getData() {
    return this[ICandidateKycAccount.data];
  }
}
